import React, { Component } from 'react';
import styled from 'styled-components';

import TinySpinner from './TinySpinner';

class Button extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleOnClick() {
        if(this.props.onClick && !this.props.disabled) {
            this.props.onClick();
        }
    }

    renderLoader() {
        if(this.props.busy) {
            return (
                <TinySpinner />
            )
        }
    }

    render() { 
        return (
            <div className={"hw-widget__button" + (this.props.busy || this.props.disabled ? " hw-widget__button--disabled" : "") + (this.props.className ? ` ${this.props.className}` : "")} onClick={() => this.handleOnClick()}>{this.renderLoader()}{this.props.children}</div>
        );
    }
}
 
export default Button;